import { slotValidate } from '../../application/dtos/slot_validate';

export class slotEntity {
    constructor({id, name, tote_id, station_id, tote, station, position}){
        this.id = id;
        this.name = name;
        this.tote_id = tote_id;
        this.station_id = station_id;
        this.tote = tote;
        this.station = station;
        this.position = position;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return slotValidate(this);
    }
}